import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomePlus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-plus"><path d="M3.75 8.75V20.25H20.25V8.75L12 3.75L3.75 8.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 10V16" stroke="currentColor" strokeWidth="1.5"/><path d="M9 13H15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHomePlus;
